import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgSortDirection = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 6 10"
    ref={ref}
    {...props}
  >
    <path fill="#FF6A38" d="M2.858 10 .383 5.714h4.95z" />
    <path fill="#AEAEAE" d="m2.857 0 2.475 4.286H.381z" />
  </svg>
);
const ForwardRef = forwardRef(SvgSortDirection);
export default ForwardRef;
